module.exports = __webpack_public_path__ + "img/banner5.24c9ff2b.png";